import { createRoot } from "react-dom/client";
import CartApp from "./CartApp.jsx";
import "./cart.scss";
import { azUrl } from '../core/config.js';

const container = document.getElementById("ai-zippy-cart");

if (container) {
	const checkoutUrl = container.dataset.checkoutUrl || azUrl('checkout');
	const shopUrl = container.dataset.shopUrl || azUrl('shop');
	createRoot(container).render(
		<CartApp checkoutUrl={checkoutUrl} shopUrl={shopUrl} />,
	);
}
